<template lang="pug">
  .v-container.u-align-center
    h5.u-weight-bold What's Import Fees?
    .u-mtm
      p.u-align-left(v-if="shippingAddress && shippingAddress.country === 'CA'") A surcharge is necessary for products shipping from the US. Calculation is based on customs duties, PST/GST, and potential handling fees usually paid by the customer at the time of delivery. The charge is not a part of your shipping fee, and is exempt from Free Shipping promotions. Visit #[a(href="https://otakumode.com/hc/shop/shipping_and_delivery/shipping_methods/5c21e6cee702e8327d8806b6" target="_blank") Shipping FAQ] for more info.
      p.u-align-left(v-else) With the shipping method you have selected, import tariffs and any related handling surcharges are all paid up front. You will not be asked to pay any extra customs fees before receiving your product. Import fees are exempt from free shipping promotions.
    .u-mtm
      a.c-btn.c-btn--primary.c-btn--round.u-pll.u-prl(href="#", @click.prevent="$emit('close')") OK
</template>

<script>
  export default {
    name: 'import-fees',
    props: {
      shippingAddress: Object
    }
  };
</script>

<style scoped>
  .v-container {
    padding: 40px;
  }
</style>
